<ng-container>
  <div class="log-metadata">
    <div class="v-center" style="gap: 8px;">
      <div class="log-metadata-time">{{log.eventCreated}}</div>
      <div class="log-metadata-category">
        <div class="badge" *ngIf="checkArmingStatus()" [ngClass]="computedActionName(log.action)+ '-background'">{{ capitalizeFirstLetter(log.action) }}</div>
        <div class="badge default-background" *ngIf="!checkArmingStatus()">{{ capitalizeFirstLetter(log.action) }}</div>
      </div>
    </div>
    <div class="log-metadata-category">
      <div class="badge automation" *ngIf="isAutomationRule(log)" style="margin-left: 4px">Automation Action</div>
    </div>
    <div class="log-metadata-category">
      <ng-container *ngFor="let list of log.eventCodeList">
        <div class="badge xml-code">{{ list.code }}</div>
      </ng-container>
    </div>
    <div class="log-metadata-device">
      <div class="log-metadata-device-zone" *ngIf="log.zone_number">{{log.zone_number}}</div>
      <div class="log-metadata-device-name v-center" [class.no-name]="!log.name">
        <div *ngIf="log?.partitionNumber || log?.partitionName">
          Partition {{ log?.partitionNumber }} ({{log?.partitionName}})
        </div>
        <div *ngIf="!log?.partitionNumber" style="margin-left: 4px">
          {{log.name ?? 'No Name'}}
        </div>
      </div>
    </div>
    <div class="log-metadata-other">
      <ng-container *ngIf="!log.email">{{log.trigger}} - {{log.status_text}}</ng-container>
      <ng-container *ngIf="log.email">{{log.email}} - {{log.status_text}}</ng-container>
      <div *ngIf="log?.partnerDescription">{{ log?.partnerDescription }}</div>
    </div>
  </div>
</ng-container>
